import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  loadingButton: {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.primary.main,
      opacity: 1,
    },
  },
  content: {
    width: '100%',
    maxWidth: 420,
    marginInline: 'auto',
  },
  recaptchaContainer: {
    display: 'flex', width: '100%', justifyContent: 'center', marginTop: 20,
  },
  errorRegion: {
    minHeight: '1.5rem',
    marginTop: 12,
    marginBottom: 12,
    textAlign: 'left',
  },
  secondaryActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    marginTop: 16,
  },
}));

export default useStyles;
